import type { WheelPickerOption } from '~/shared/ui/WheelPicker'

/** Шаг минут по умолчанию — спека 01 §7 использует 5 только для будильника прогноза. */
export const DEFAULT_MINUTE_STEP = 1

/** Дефолтное время, когда value ещё не выбрано — спека 02 «дефолт 9:00». */
export const DEFAULT_TIME_VALUE = { hours: 9, minutes: 0 }

export const HOUR_OPTIONS: WheelPickerOption[] = Array.from({ length: 24 }, (_, hour) => ({
  value: String(hour),
  label: String(hour).padStart(2, '0'),
}))

export function buildMinuteOptions(step: number): WheelPickerOption[] {
  const count = Math.max(1, Math.floor(60 / step))
  return Array.from({ length: count }, (_, index) => {
    const minute = index * step
    return { value: String(minute), label: String(minute).padStart(2, '0') }
  })
}
